import { APIMethod, fetchData } from "@client";
import { PROJECT_STATUS } from "@utils";

export async function getArchivedProjectsQuery(workspaceUuid, page, query, limit = 10) {
  const { results, paginate } = await fetchData(
    `/project`,
    APIMethod.GET,
    {
      params: {
        workspace: workspaceUuid,
        status: PROJECT_STATUS.ARCHIVE,
        page,
        limit,
        query,
      }
    }
  );

  return { results, ...paginate };
}
